
import { Fragment, useEffect, useMemo, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from "@mui/material";
import visileColumns from "./visibleColumns";
import AdvanceSearch from "../../CommonComponents/AdvanceSearch";
import ErrorBoundary from "../../ErrorBoundry";
import { useNavigate } from "react-router-dom";
import { useAuth } from "oidc-react";

import { deleteJobPosition, reset } from "../../store/position/actions";
import { Icon } from "@progress/kendo-react-common";
import useSortedColumns from "../../utils/useSortedColumns";
import TelerikDataTable from "../../CommonComponents/TelerikDataTable";
import { ExpandMore } from "@mui/icons-material";
import { Btn } from "../../AbstractElements";


function JobPositionRequirement() {
    const dispatch = useDispatch();
    const {
        columns,
        loadingSearch,
        searchResults,
        ColumnsSorted,
        searchParameter,
        searchResults: { results, rowCount },
    } = useSelector((state) => state.advanceSearchv2Reducer);
    const { filter: storeFilter, pageSize: storePageSize } = useSelector(
        (state) => state.CommonReducer
    );
    const { postingResult, loading } = useSelector(
        (state) => state.PositionReducer
    );
    const navigate = useNavigate();
    // const [currentColumns, setCurrentColumns] = React.useState(visileColumns);
    const [expandedSearchResult, setexpandedSearchResult] = useState(false);
    const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
    // const [sortedColumns,setSortedColumns]=useState([])
    // const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(1);
    const { userData } = useAuth();
    const id = "position";
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [gg1ExportParams, setGG1ExportParams] = useState({});

    const getParamData = (data) => {
        setGG1ExportParams(data);
    };
    const [tableAdditionalWhere, setTableAdditionalWhere] = useState("");
    const [sortData, setSortData] = useState();
    const [searchParams, setSearchParams] = useState([]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);

    const [deleteData, setDeleteData] = useState(null);
    const [requirementFilter, setRequirementFilter] = useState("all");
    const additionalWhere = useMemo(() => {
        const requirementClause =
            requirementFilter === "requirement"
                ? "IsRequirementAvailable = 1"
                : requirementFilter === "no-requirement"
                    ? "IsRequirementAvailable = 0"
                    : "";

        if (tableAdditionalWhere && requirementClause) {
            return `(${tableAdditionalWhere}) AND (${requirementClause})`;
        }
        return tableAdditionalWhere || requirementClause || "";
    }, [tableAdditionalWhere, requirementFilter]);

    const handleReset = () => {
        dispatch(reset());
    };

    const actions = useMemo(() => {
        return [
            {
                title: "Show Details",
                action: (props) => {
                    return navigate(`/jobPositionRequirement/${props.dataItem.NPOSITION_NO}`);
                },
                icon: { iconName: "k-icon  k-i-eye" },
                className: "font-primary",
                style: { cursor: "pointer" },
            }
        ];
    });

    useEffect(() => {
        if (loadingSearch) setexpandedSearchResult(true);
    }, [loadingSearch]);

    useEffect(() => {
        if (
            postingResult !== undefined &&
            Object.keys(postingResult).length > 0 &&
            loading === false
        ) {
            setDeleteData({ dt: new Date() });
        }
    }, [postingResult, loading]);

    useEffect(() => {
        // console.log(searchResults);
    }, [searchResults]);

    const [sortedColumns, setSortedColumns] = useSortedColumns(
        id,
        ColumnsSorted,
        columns,
        visileColumns,
        userData
    );
    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };
    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };
    const handleFilterChange = (data) => {
        setTableAdditionalWhere(data || "");
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };
    const handleRequirementFilterChange = (event) => {
        setRequirementFilter(event.target.value);
        setPage(1);
    };

    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    return (
        <ErrorBoundary>
            {" "}
            <Fragment>
                <Container fluid={true}>
                    <Row className="bg-primary rounded py-3 mb-3">
                        <Typography variant="h5">
                            <Icon
                                style={{ fontSize: "25px", margin: "10px" }}
                                name="file-ascx"
                            />
                            Job Positions Requirement
                        </Typography>
                    </Row>
                    <Row>
                        <Col sm="12" className="page-content">
                            <Card>
                                <CardBody>
                                    <AdvanceSearch
                                        id={id}
                                        gridId={id}
                                        location="JobApplicant-global"
                                        getParamData={getParamData}
                                        columnList={"*"}
                                        columnRefernces={[]}
                                        tableName={"vw_job_interest"}
                                        searchParams={searchParams}
                                        additionalWhere={additionalWhere}
                                        expanded={true}
                                        sortData={sortData}
                                        pageNumber={page}
                                        pageSize={pageSize}
                                        deleteData={deleteData}
                                        chooseFilterMethod={chooseFilterMethod}
                                        applicationName={"JobApplication"}
                                    />
                                    <Accordion expanded={expandedSearchResult}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMore />}
                                            className="bg-light"
                                            onClick={() =>
                                                setexpandedSearchResult(!expandedSearchResult)
                                            }
                                        >
                                            <Typography variant="h6">Search Filter</Typography>
                                            <div className="d-flex gap-3 ms-auto" onClick={(e) => e.stopPropagation()}>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input type="radio" name="requirement" value="all" checked={requirementFilter === "all"} onChange={handleRequirementFilterChange} style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                                                    All
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input type="radio" name="requirement" value="requirement" checked={requirementFilter === "requirement"} onChange={handleRequirementFilterChange} style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                                                    Requirement
                                                </label>
                                                <label className="d-flex align-items-center gap-1">
                                                    <input type="radio" name="requirement" value="no-requirement" checked={requirementFilter === "no-requirement"} onChange={handleRequirementFilterChange} style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                                                    No Requirement
                                                </label>
                                            </div>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {/* {loadingSearch && loadingPanel} */}
                                            <div>
                                                {sortedColumns.length > 0 && (
                                                    <TelerikDataTable
                                                        id={id}
                                                        pageSize={pageSize}
                                                        totalCount={rowCount}
                                                        skip={(page - 1) * pageSize}
                                                        take={pageSize}
                                                        data={results || []}
                                                        sortData={sortData}
                                                        onFilterChange={handleFilterChange}
                                                        onSortChange={handleSortChange}
                                                        onPageChange={handlePageChange}
                                                        onPageSizeChange={handlePageSizeChange}
                                                        selectedColumns={sortedColumns}
                                                        setSortedColumns={setSortedColumns}
                                                        loading={loadingSearch}
                                                        actions={actions}
                                                        setChooseFilterMethod={setChooseFilterMethod}
                                                        chooseFilterMethod={chooseFilterMethod}
                                                    ></TelerikDataTable>
                                                )}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        </ErrorBoundary>
    );
}
export default JobPositionRequirement;
